import { ThemeConfig } from "../models/theme.model";

/** Theme ID for the built-in default theme. The app always has this theme available without requiring the API to return it. */
export const BUILT_IN_THEME_ID = "theme_jepto";

/**
 * Returns true if the theme ID is a built-in theme (e.g. theme_jepto).
 * Built-in themes are stored in the app and do not need to be returned by the API.
 */
export function isBuiltInThemeId(themeId: string): boolean {
  return themeId === BUILT_IN_THEME_ID;
}

/**
 * Default theme configuration (built-in).
 *
 * Stored in the app; used when no custom theme is provided or when the view
 * requests the default theme. The API does not need to return this theme.
 */
export const DEFAULT_THEME: ThemeConfig = {
  themeId: BUILT_IN_THEME_ID,
  palette: "pal_jepto",
  maxWidth: "auto",
  padding: "20px",
  card: {
    borderRadius: "4px",
    borderWidth: "0px",
    spacing: "16px",
    padding: "12px",
    contentAlignment: "left",
    headingWeight: "bold",
    titleWeight: "semibold",
    headerMarginBottom: "4px",
    headerPaddingBottom: "6px",
    titleMarginBottom: "4px",
    iconSize: "20px",
    iconMarginRight: "11px",
  },
  colors: {
    light: {
      background: "#F5F5F5",
      border: {
        primary: "#7D818A",
        secondary: "#E2E3E5",
      },
      card: {
        background: "#FFFFFF",
        shadow: "#00000026",
      },
      text: {
        primary: "#0F1526D1",
        secondary: "#0F15268A",
        link: "#651FFF",
      },
      status: {
        success: "#66BB6A",
        warning: "#F5F5F5",
        danger: "#F3403D",
        info: "#42A5F5",
      },
    },
    dark: {
      background: "#0F1526",
      border: {
        primary: "#646A7F",
        secondary: "#363B4E",
      },
      card: {
        background: "#1A2036",
        shadow: "#0000004D",
      },
      text: {
        primary: "#FFFFFF",
        secondary: "#FFFFFFB8",
        link: "#AB7AFF",
      },
      status: {
        success: "#81C784",
        warning: "#FFB74D",
        danger: "#EF5350",
        info: "#64B5F6",
      },
    },
  },
  typography: {
    fontFamily: "proxima-nova",
    baseSize: "16px",
    size: {
      xxs: 0.625,
      xs: 0.75,
      sm: 0.875,
      md: 1,
      lg: 1.1,
      xl: 1.5,
      xxl: 2,
    },
    lineHeight: {
      tight: 1.1,
      normal: 1.5,
      loose: 1.8,
      double: 2,
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
};
